
import { XMarkIcon } from '@heroicons/react/24/outline'
import moment from 'moment'
import { useLocation } from 'react-router-dom'
import Spinner from '../../../Componenten/Spinner'
import { Attachments } from '../../../Componenten/Documenten/Attachments'
import VragenlijstenResumer from '../../../Componenten/Vragenlijsten/VragenlijstenResumer'
import { useLayoutEffect, useState } from 'react'
import { AXIOS_GET } from '../../../server/api/crud'
import Commentaar from '../../../Componenten/Commentaar'
import { getUserdetails } from '../../../Localstorage/localstorage'
import RP_Avatar from '../../../Componenten/RP_Avatar'


  const eventTypes = {
    applied: { icon: XMarkIcon, bgColorClass: 'bg-red-400' },
    advanced: { icon: XMarkIcon, bgColorClass: 'bg-red-500' },
    completed: { icon: XMarkIcon, bgColorClass: 'bg-red-500' },
  }
  
  const timeline = [
    {
      id: 1,
      type: eventTypes.applied,
      content: 'Pre-intake formulier',
      target: 'Niet ingevuld',
      date: 'Sep 20',
      datetime: '2020-09-20',
    },
    {
      id: 2,
      type: eventTypes.advanced,
      content: 'Klachtenregistratie formulier',
      target: 'Niet ingevuld',
      date: 'Sep 22',
      datetime: '2020-09-22',
    },
    {
      id: 3,
      type: eventTypes.advanced,
      content: 'VoedingsDagboek formulier',
      target: 'Niet ingevuld',
      date: 'Sep 22',
      datetime: '2020-09-22',
    }
  ]

  const CalculateAge = ( birthDate ) => {
    // Get the current date
    const currentDate = moment();
    
    // Create a moment object for the birthdate
    const birthDateMoment = moment(birthDate, 'YYYY-MM-DD'); // Adjust format as needed

    // Calculate the age
    const age = currentDate.diff(birthDateMoment, 'years');
    
    return age
  };
  
  const DetailProfiel = () => {

    const usernav = useLocation();
    const {user} = usernav?.state;
    const [attachments, setAttachments] = useState([])
    const [, setVragenlijst] = useState(null)

    const userAdmin = getUserdetails();

    const getDocumentByID = async (p_user_id) =>{
      await AXIOS_GET(`documents/user/${p_user_id}`).then((res)=>{
          setAttachments(res.data.data)
      })
    }

    const fetchData = async (p_id) => {
      try {
        const response = await AXIOS_GET(`vragenlijsten/${p_id}`);
        setVragenlijst(response.data.data[0])

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    useLayoutEffect(() => {
      if (!user?.user_id) return;
      const { user_id } = user;
      void getDocumentByID(user_id);
      void fetchData(user_id);
    }, [user?.user_id])
    

  if (user) return (
        <div className="h-fit min-h-0 bg-wa-app text-wa-text">
          <main className="h-fit py-6 sm:py-10">
            <div className="mx-auto max-w-3xl px-4 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:max-w-7xl lg:px-8">
              <div className="flex items-center space-x-4 sm:space-x-5">
                <div className="flex-shrink-0">
                  <div className="relative">
                    <RP_Avatar avatar={user?.userdetails_avatar} size={16} alt={` ${user?.userdetails_full_name}`} />
                    <span aria-hidden="true" className="absolute inset-0 rounded-full shadow-inner ring-1 ring-wa-border" />
                  </div>
                </div>
                <div className="min-w-0">
                  <h1 className="truncate text-2xl font-bold tracking-tight text-wa-text">
                    Hallo, {user?.userdetails_full_name}{" "}
                    <span className="text-base font-medium text-wa-muted sm:text-lg">
                      {user?.userdetails_date_of_birth
                        ? `(${CalculateAge(user?.userdetails_date_of_birth)} jaar)`
                        : ""}
                    </span>
                  </h1>
                  <p className="mt-1 text-sm text-wa-muted">
                    <span className="text-wa-text">Geboortedatum</span>{" "}
                    <time dateTime={user?.userdetails_date_of_birth || undefined}>
                      {user?.userdetails_date_of_birth
                        ? moment(user?.userdetails_date_of_birth).format("LL")
                        : "?"}
                    </time>
                  </p>
                </div>
              </div>
            </div>

            <div className="mx-auto mt-6 grid max-w-3xl grid-cols-1 gap-5 px-4 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3 lg:gap-6 lg:px-8">
              <div className="min-w-0 space-y-5 lg:col-span-2 lg:col-start-1">
                <section aria-labelledby="applicant-information-title">
                  <div className="overflow-hidden rounded-lg border border-wa-border bg-wa-panel shadow-sm">
                    <div className="border-b border-wa-border px-4 py-5 sm:px-6">
                      <h2
                        id="applicant-information-title"
                        className="text-lg font-semibold leading-6 text-wa-text"
                      >
                        Informatie van de patient
                      </h2>
                      <p className="mt-1 max-w-2xl text-sm text-wa-muted">
                        Samenvatting van zijn gehele gezondheidsevolutie
                      </p>
                    </div>
                    <div className="px-4 py-5 sm:px-6">
                      <dl className="grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2">
                        <div>
                          <dt className="text-xs font-medium uppercase tracking-wide text-wa-accent">
                            Geregistreerd op
                          </dt>
                          <dd className="mt-1 text-sm text-wa-text">
                            {moment(user?.created_at).format("LLLL")}
                          </dd>
                        </div>
                        <div>
                          <dt className="text-xs font-medium uppercase tracking-wide text-wa-muted">
                            Email address
                          </dt>
                          <dd className="mt-1 break-all text-sm text-wa-text">
                            {user?.userdetails_email}
                          </dd>
                        </div>
                        <div>
                          <dt className="text-xs font-medium uppercase tracking-wide text-wa-muted">
                            Klacht
                          </dt>
                          <dd className="mt-1 text-sm text-wa-text">
                            {user?.userdetails_klacht}
                          </dd>
                        </div>
                        <div>
                          <dt className="text-xs font-medium uppercase tracking-wide text-wa-muted">
                            Phone
                          </dt>
                          <dd className="mt-1 text-sm text-wa-text">
                            {user?.userdetails_phone_number}
                          </dd>
                        </div>
                        <div className="sm:col-span-2">
                          <dt className="text-xs font-medium uppercase tracking-wide text-wa-muted">
                            Situatie
                          </dt>
                          <dd className="mt-1 whitespace-pre-wrap text-sm text-wa-text">
                            {user?.userdetails_more_details}
                          </dd>
                        </div>
                      </dl>
                      {attachments?.length > 0 && (
                        <div className="mt-6 border-t border-wa-border pt-6">
                          <Attachments attachments={attachments} />
                        </div>
                      )}
                    </div>
                  </div>
                </section>

                <Commentaar admin={userAdmin} user={user} />
              </div>

              <VragenlijstenResumer
                timeline={timeline}
                vragenlijst={{
                  klacht_verstuur: user?.vragenlijsten_klacht_verstuur,
                  preintake_verstuur: user?.vragenlijsten_preintake_verstuur,
                  voeding_verstuur: user?.vragenlijsten_voeding_verstuur,
                }}
                user={user}
              />
            </div>
          </main>
        </div>
    )

    return(<Spinner/>)
  }

  export default DetailProfiel
